/**
 * One-shot "return here after sign-in" URL.
 *
 * Used by the assigner flow: the Assigner Request page is a public email link,
 * but Manage Referee Assignment needs a signed-in user. When the assigner is
 * not signed in we remember the Manage page URL, send them to login, and
 * AuthService.get_user_aci() (which runs on the home page right after login)
 * consumes it.
 *
 * Only same-app relative paths are accepted so this can never become an open
 * redirect. localStorage access is wrapped because it can throw in private
 * mode / blocked storage.
 */
const KEY = 'post_login_redirect';

function isSafeAppPath(url: string | null | undefined): url is string {
  return !!url && url.startsWith('/') && !url.startsWith('//');
}

export function setPostLoginRedirect(url: string): void {
  if (!isSafeAppPath(url)) {
    return;
  }
  try {
    localStorage.setItem(KEY, url);
  } catch (_) {}
}

/** Returns the saved URL (if any) and clears it. */
export function consumePostLoginRedirect(): string | null {
  try {
    const url = localStorage.getItem(KEY);
    localStorage.removeItem(KEY);
    return isSafeAppPath(url) ? url : null;
  } catch (_) {
    return null;
  }
}

export function clearPostLoginRedirect(): void {
  try {
    localStorage.removeItem(KEY);
  } catch (_) {}
}

/** URL of the Manage Referee Assignment screen (same as the Assigned Referee Report). */
export function manageRefereeAssignmentUrl(fieldEventId: string, fercId: string, refsNeeded: number): string {
  const q = new URLSearchParams({
    referee_id: String(fercId),
    refs_needed: String(refsNeeded || 1),
  });
  return `/schedule-listing/manage-referee/${encodeURIComponent(fieldEventId)}?${q.toString()}`;
}
